import { useQuery } from '@tanstack/react-query';

import { getLanguageOptions } from '~/services/LabService';

const ONE_HOUR_MS = 60 * 60 * 1000;

export const languageOptionQueryKeys = {
  all: ['lab', 'remote-config', 'languages'] as const,
};

/** Supported locales sourced from the staging lab `languages` remote config (visible + pre-release). */
export function useGetLanguageOptions() {
  return useQuery({
    queryKey: languageOptionQueryKeys.all,
    queryFn: getLanguageOptions,
    staleTime: ONE_HOUR_MS,
    gcTime: ONE_HOUR_MS,
  });
}
